// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__woiKt","title":"NotFound_title__OQ-MU","content":"NotFound_content__1b9bZ","backHome":"NotFound_backHome__JANOZ"};